// Шаблон письма-подтверждения записи (от менеджера/админа) зависит от типа мероприятия —
// у обучения, путешествий и регат свой текст/тема/вложения по умолчанию.
const TYPE_SUFFIX = {
  study: 'Study',
  adventures: 'Adventures', adventure: 'Adventures',
  races: 'Races', race: 'Races',
};

// Если под конкретный тип ничего не настроено — используем старый общий шаблон
// (bookingConfirmSubject/Body/Attachments) как запасной вариант, чтобы уже
// заполненные ранее шаблоны не терялись при обновлении.
export function getBookingTemplate(content, type) {
  const suffix = TYPE_SUFFIX[type] || 'Study';
  return {
    subject:     content?.[`bookingConfirmSubject${suffix}`]     ?? content?.bookingConfirmSubject     ?? '',
    body:        content?.[`bookingConfirmBody${suffix}`]        ?? content?.bookingConfirmBody        ?? '',
    attachments: content?.[`bookingConfirmAttachments${suffix}`] ?? content?.bookingConfirmAttachments ?? [],
  };
}
